import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import * as i0 from "@angular/core";
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
var LocaleService = /** @class */ (function () {
    function LocaleService() {
    }
    LocaleService.prototype.language = function () {
        return navigator.language || navigator['userLanguage'] || 'pt-BR';
    };
    LocaleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocaleService_Factory() { return new LocaleService(); }, token: LocaleService, providedIn: "root" });
    return LocaleService;
}());
export { LocaleService };
